import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import WhyThisExists from "@/components/WhyThisExists";
import ProblemSection from "@/components/ProblemSection";
import WhatWeDoSection from "@/components/WhatWeDoSection";
import BeforeAfterSection from "@/components/BeforeAfterSection";
import WhatMakesDifferent from "@/components/WhatMakesDifferent";
import WhoItsForSection from "@/components/WhoItsForSection";
import CredibilityLine from "@/components/CredibilityLine";
import ProcessSection from "@/components/ProcessSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import SectionDivider from "@/components/SectionDivider";

const Index = () => {
  useScrollReveal();

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <SectionDivider />
        <WhyThisExists />
        <SectionDivider />
        <ProblemSection />
        <SectionDivider />
        <WhatWeDoSection />
        <SectionDivider />
        <BeforeAfterSection />
        <SectionDivider />
        <WhatMakesDifferent />
        <SectionDivider />
        <WhoItsForSection />
        <SectionDivider />
        <CredibilityLine />
        <SectionDivider />
        <ProcessSection />
        <SectionDivider />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
